export const OPEN_APP_MODAL = 'OPEN_APP_MODAL';
export const CLOSE_APP_MODAL = 'CLOSE_APP_MODAL';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const SET_PAGINATION = 'SET_PAGINATION';
export const INCREMENT_PAGINATION_TOTAL = 'INCREMENT_PAGINATION_TOTAL';
export const DECREMENT_PAGINATION_TOTAL = 'DECREMENT_PAGINATION_TOTAL';
export const SET_MESSAGES = 'SET_MESSAGES';
export const SET_ALL_MESSAGES = 'SET_ALL_MESSAGES';
export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE';
export const SET_SCHEDULES = 'SET_SCHEDULES';
export const REMOVE_SCHEDULE = 'REMOVE_SCHEDULE';
export const ADD_SCHEDULE = 'ADD_SCHEDULE';
export const UPDATE_SCHEDULE = 'UPDATE_SCHEDULE';
export const SET_TRIGGERS = 'SET_TRIGGERS';
export const REMOVE_TRIGGER = 'REMOVE_TRIGGER';
export const ADD_TRIGGER = 'ADD_TRIGGER';
export const UPDATE_TRIGGER = 'UPDATE_TRIGGER';
export const SET_ALERT = 'SET_ALERT';
export const SET_ALERT_VISIBILITY = 'SET_ALERT_VISIBILITY';
